//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { ITikTokUser } from '@apis/tiktok-user/tiktokUserApiModel';
import { Serialized } from '@utils/types/Serialized';

export const deserializeUser = (user: Serialized<ITikTokUser>): ITikTokUser => {
  return {
    ...user,
    dailyMetrics: user.dailyMetrics.map((dailyMetric) => ({
      ...dailyMetric,
      date: dailyMetric.date ? new Date(dailyMetric.date) : undefined,
    })),
  };
};
